import React from "react";
import PropTypes from "prop-types";

function CheckmarkLight({
  className,
  style,
  fill,
  defaultWidth,
  defaultHeight
}) {
  return (
    <svg
      viewBox="0 0 448 512"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.width ? style.height : defaultHeight}
      style={style}
      className={`svg-inline--fa fa-check fa-w-14 ${className || ""}`}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      data-prefix="far"
      data-icon="check"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        d="M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z"
      ></path>
    </svg>
  );
}

CheckmarkLight.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string
};

CheckmarkLight.defaultProps = {
  className: undefined,
  defaultHeight: 448,
  defaultWidth: 512,
  fill: "#26e3ba"
};

export default CheckmarkLight;
